// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ##### -> Components -> FaulTree  #####*/

.tree {
  display: inline-block;
  overflow-x: auto; /* Ensure it doesn’t hide content */
  min-width: max-content; /* Expands to fit the widest content */
}

.tree ul {
  display: flex;
  justify-content: center;
  padding-top: 1vmax;
  flex-wrap: nowrap; /* Prevents breaking to the next line */
  min-width: max-content; /* Ensures all elements fit inside */
  position: relative;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 1.5vmax 0.2vmax 0 0px;
  padding: 2.5vmax 0.2vmax 0 0px;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li::before,
.tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 3px solid #ccc;
  width: 50%;
  /* height: 1.4vmax; */
  height: 2.4vmax;
}

.tree li::after {
  right: auto;
  left: 50%;
  border-left: 3px solid #ccc;
}

.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

.tree li:only-child {
  padding-top: 0;
}

.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}

.tree li:last-child::before {
  border-right: 3px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}

.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

.tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 3px solid #ccc;
  width: 0;
  /* height: 0.7vmax; */
  height: 1.3vmax;
}

.tree ul {
  /* padding: 0.7vmax 0.3vmax !important; */
  padding: 1.3vmax 0.3vmax !important;
}

.tree li div {
  border: 1px solid #ccc;
  text-decoration: none;
  color: black;
  font-size: 0.7vmax;
  font-weight: 600;
  display: inline-block;
  text-align: center;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li div:hover,
.tree li div:hover + ul li div {
  background: #c8e4f8 !important;
  /* color: #000; */
  /* border: 1px solid #94a0b4; */
  /* border: 3px solid #ee6916; */
}

.tree li div:hover + ul li::after,
.tree li div:hover + ul li::before,
.tree li div:hover + ul::before,
.tree li div:hover + ul ul::before {
  border-color: #94a0b4;
}

.scroll-tree-container {
  min-height: 75vh;
  width: 100%;
  overflow-x: auto; /* Enable horizontal scrolling */
  overflow-y: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/modules/prescriptiveModel/FaultTree.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,qBAAqB;EACrB,gBAAgB,EAAE,mCAAmC;EACrD,sBAAsB,EAAE,sCAAsC;AAChE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB,EAAE,uCAAuC;EAC1D,sBAAsB,EAAE,oCAAoC;EAC5D,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,UAAU;EACV,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAE,gCAAgC;EAClD,kBAAkB;AACpB","sourcesContent":["/* ##### -> Components -> FaulTree  #####*/\n\n.tree {\n  display: inline-block;\n  overflow-x: auto; /* Ensure it doesn’t hide content */\n  min-width: max-content; /* Expands to fit the widest content */\n}\n\n.tree ul {\n  display: flex;\n  justify-content: center;\n  padding-top: 1vmax;\n  flex-wrap: nowrap; /* Prevents breaking to the next line */\n  min-width: max-content; /* Ensures all elements fit inside */\n  position: relative;\n  transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n}\n\n.tree li {\n  float: left;\n  text-align: center;\n  list-style-type: none;\n  position: relative;\n  padding: 1.5vmax 0.2vmax 0 0px;\n  padding: 2.5vmax 0.2vmax 0 0px;\n  transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n}\n\n.tree li::before,\n.tree li::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 50%;\n  border-top: 3px solid #ccc;\n  width: 50%;\n  /* height: 1.4vmax; */\n  height: 2.4vmax;\n}\n\n.tree li::after {\n  right: auto;\n  left: 50%;\n  border-left: 3px solid #ccc;\n}\n\n.tree li:only-child::after,\n.tree li:only-child::before {\n  display: none;\n}\n\n.tree li:only-child {\n  padding-top: 0;\n}\n\n.tree li:first-child::before,\n.tree li:last-child::after {\n  border: 0 none;\n}\n\n.tree li:last-child::before {\n  border-right: 3px solid #ccc;\n  border-radius: 0 5px 0 0;\n  -webkit-border-radius: 0 5px 0 0;\n  -moz-border-radius: 0 5px 0 0;\n}\n\n.tree li:first-child::after {\n  border-radius: 5px 0 0 0;\n  -webkit-border-radius: 5px 0 0 0;\n  -moz-border-radius: 5px 0 0 0;\n}\n\n.tree ul ul::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border-left: 3px solid #ccc;\n  width: 0;\n  /* height: 0.7vmax; */\n  height: 1.3vmax;\n}\n\n.tree ul {\n  /* padding: 0.7vmax 0.3vmax !important; */\n  padding: 1.3vmax 0.3vmax !important;\n}\n\n.tree li div {\n  border: 1px solid #ccc;\n  text-decoration: none;\n  color: black;\n  font-size: 0.7vmax;\n  font-weight: 600;\n  display: inline-block;\n  text-align: center;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n}\n\n.tree li div:hover,\n.tree li div:hover + ul li div {\n  background: #c8e4f8 !important;\n  /* color: #000; */\n  /* border: 1px solid #94a0b4; */\n  /* border: 3px solid #ee6916; */\n}\n\n.tree li div:hover + ul li::after,\n.tree li div:hover + ul li::before,\n.tree li div:hover + ul::before,\n.tree li div:hover + ul ul::before {\n  border-color: #94a0b4;\n}\n\n.scroll-tree-container {\n  min-height: 75vh;\n  width: 100%;\n  overflow-x: auto; /* Enable horizontal scrolling */\n  overflow-y: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
